/**
 * 需求来源：/advertisingservice 页 React SSR 迁移。
 * 本页原为纯静态落地页（无后端接口），fetch.js 仅解析 ossHost / fullName 并返回复用原页的 __seo。
 * 注意事项：
 *  1. ossHost 解析链路与参考页 printonDemand/home 一致：优先取 egg ctx.app.config.view.variable.OSS_HOST，
 *     CSR 回退 window.OSS_HOST / 全局 CDN_HOST（各环境 OSS_HOST 与 CDN_HOST 等值，可互为兜底）。
 *  2. fullName 取站点 siteCheck.data('full-name')（如 CJdropshipping），缺省回退 'CJdropshipping'，用于 SEO 文案插值。
 *  3. __seo 复用原页 SEO：title/description/keywords（见下）。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @param {Function} request - 框架注入的统一请求函数（本页无接口，未使用）
 * @returns {Object} 页面初始化数据 { ossHost, fullName, __seo }
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  let ossHost = '';
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
    ossHost = (viewVar && (viewVar.OSS_HOST || viewVar.CDN_HOST)) || '';
  }
  // CSR 兜底：从 layout 模板注入的全局变量获取
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  if (!ossHost && typeof window !== 'undefined' && window.OSS_HOST) {
    ossHost = window.OSS_HOST;
  }
  if (!ossHost && typeof CDN_HOST !== 'undefined') {
    ossHost = CDN_HOST;
  }
  if (!ossHost) {
    ossHost = cdnHost;
  }

  // fullName 取 siteCheck.data('full-name')，缺省 CJdropshipping
  let fullName = '';
  try {
    if (eggCtx && eggCtx.siteCheck && typeof eggCtx.siteCheck.data === 'function') {
      fullName = eggCtx.siteCheck.data('full-name') || '';
    }
  } catch (e) { fullName = ''; }
  if (!fullName && typeof window !== 'undefined' && window.siteCheck && typeof window.siteCheck.data === 'function') {
    try { fullName = window.siteCheck.data('full-name') || ''; } catch (e) { /* ignore */ }
  }
  if (!fullName) { fullName = 'CJdropshipping'; }

  // 260715：siteName 取 siteCheck.data('name')（如 CJ），缺省回退 'CJ'，用于固定文案 {{name}} 插值。
  let siteName = '';
  try {
    if (eggCtx && eggCtx.siteCheck && typeof eggCtx.siteCheck.data === 'function') {
      siteName = eggCtx.siteCheck.data('name') || '';
    }
  } catch (e) { siteName = ''; }
  if (!siteName && typeof window !== 'undefined' && window.siteCheck && typeof window.siteCheck.data === 'function') {
    try { siteName = window.siteCheck.data('name') || ''; } catch (e) { /* ignore */ }
  }
  if (!siteName) { siteName = 'CJ'; }

  return {
    ossHost: ossHost,
    fullName: fullName,
    siteName: siteName,
    // 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md 第35次提交（需求79）—— 更新广告开户页 SEO 文案（原文见文档）；
    // 文案中的品牌名 CJdropshipping 走 fullName（缺省 CJdropshipping）保持多站点一致。
    __seo: {
      title: `Advertising Account Opening Service | Meta, Google & TikTok Ads | ${fullName}`,
      description: `Open Meta, Google, TikTok, and AppLovin advertising accounts with ${fullName}. Get official partner resources, stable ad accounts, expert support, and start advertising globally.`,
      keywords: `advertising account opening, Meta ads account, Facebook advertising account, Google Ads account, TikTok Ads account, AppLovin account, advertising agency, ecommerce advertising, global advertising service, ${fullName}`,
    },
  };
}

module.exports = fetchData;
